import { z } from 'zod';
// ============================================================================
// Doc Splitter Config Schemas (Browser-safe)
// ============================================================================
/**
 * Schema for groupBy options - defines checkbox/category options for forms that need sub-grouping
 */
export const GroupByOptionSchema = z.object({
    /** The value to use in groupByValue (e.g., "passive", "general") */
    value: z.string().min(1),
    /** Human-readable label for LLM prompt (e.g., "Passive category income") */
    label: z.string().min(1),
    /** Display name for UI/output (e.g., "Passive Category") */
    displayName: z.string().min(1),
});
export const FormFamilySchema = z.object({
    familyId: z.string().min(1),
    displayName: z.string().min(1),
    parentForm: z.string().nullable(),
    childForms: z.array(z.string()),
    exclude: z.array(z.string()).optional().default([]),
    groupBy: z.string().optional(),
    /** Options for groupBy - used for category detection when LLM needs to identify checkbox selection */
    groupByOptions: z.array(GroupByOptionSchema).optional(),
    /** Patterns to match in page header for body text inclusion (e.g., ["form 1116", "foreign tax credit"]) */
    bodyTextMatchPatterns: z.array(z.string()).optional(),
});
export const BundlingOptionsSchema = z.object({
    requireConsecutive: z.boolean().default(true),
    preserveOrder: z.boolean().default(true),
});
export const VersionedConfigSchema = z.object({
    formFamilies: z.array(FormFamilySchema),
    bundlingOptions: BundlingOptionsSchema.optional(),
});
//# sourceMappingURL=DocSplitterSchemas.js.map